<template>
  <section class="c_cs_text" ref="c_cs_text">
    <div class="c_wrapper c_wrapper--950">
      <h2 class="c_2022--h2_graphik" v-if="header">{{ header }}</h2>
      <div class="c_cs_text__container" v-if="text" v-html="text"></div>
      <div v-if="divider" role="presentation" class="c_cs_text__divider c_2022--body"></div>
    </div>
  </section>
</template>

<script>
import { openPdfsInNewTab } from 'JS/global.js';
export default {
  props: {
    header: String,
    text: String,
    divider: Boolean,
  },
  mounted() {
    openPdfsInNewTab(this.$refs.c_cs_text);
  },
};
</script>

<style lang="scss">
.c_cs_text {
  $self: &;
  padding: px_to_rem(34) 0;
  @include font('graphik_regular');
  @include mq($mq_sm_to_md) {
    padding: px_to_rem(25) 0;
  }
  h2 {
    @include font('graphik_medium');
    margin-bottom: px_to_rem(5);
  }
  p {
    margin-bottom: px_to_rem(20);
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  ul {
    list-style-type: disc;
    margin-left: px_to_rem(15);
    margin-bottom: px_to_rem(20);
  }
  em {
    @include font('graphik_regular_italic');
  }
  ol {
    margin-left: px_to_rem(15);
    margin-bottom: px_to_rem(20);
  }
  strong {
    @include font('graphik_semibold');
  }
  a,
  a:visited {
    color: $color_red;
    &:hover {
      text-decoration: none;
    }
  }
  @at-root #{&}__divider {
    height: px_to_rem(10);
    background-color: $color_yellow;
    margin: px_to_rem(40) 0 0;
    @include mq($mq_sm_to_md) {
      margin: px_to_rem(50) 0 0;
    }
  }
}
</style>
